import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({providedIn: 'root'})
export class StyleBuilder {

  constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string) { }

  menuBackgroundColor = '#d9dfe8';
  menuFontColor = '#343a40';
  primaryButtonBackgroundColor = '#007bff';
  primaryButtonFontColor = '#fff';
  loginLogoImage = 'assets/images/TransUnion_Workflow_Login.png';
  errorMessage: string;

  private getStyleConfig() {
    return this.http.get<any>('/api/webClientConfig/getStyleConfig');
  }

  setLayoutConfig() {
    this.errorMessage = '';
    this.getStyleConfig()
      .subscribe( result => {
        localStorage.setItem('extendedLogo', result.extendedMenuLogoImage);
        localStorage.setItem('collapsedLogo', result.collapsedMenuLogoImage);
        this.generateStyles(
          result.menuBackgroundColor,
          result.menuFontColor,
          result.buttonBackgroundColor,
          result.buttonFontColor,
          result.loginLogoImage
        );
      }, error1 => {
        this.errorMessage = `<p>Falha ao obter as configurações do ClientWeb.</p> ${error1}`;
        this.generateStyles(
          this.menuBackgroundColor,
          this.menuFontColor,
          this.primaryButtonBackgroundColor,
          this.primaryButtonFontColor,
          this.loginLogoImage
        );
      });
  }

  private generateStyles(menuBackgroundColor, menuFontColor, buttonBackgroundColor, buttonFontColor, loginLogoImage) {
    const css =
      `
          .login-logo {
            height: 6.5rem;
            background: url('${loginLogoImage}') no-repeat;
            background-size: contain;
            background-position: center;
          }
          body,
          .login-page, .register-page,
          .content-wrapper,
          .sidebar-light-primary,
          .navbar-glass,
          .navbar-vertical .navbar-collapse {
            background-color: ${menuBackgroundColor};
          }
          .navbar-light, .main-footer {
            border-color: ${menuBackgroundColor};
            background-color: ${menuBackgroundColor};
          }
          .brand-link {
            border-color: ${menuBackgroundColor};
          }
          [class*="sidebar-light"] .brand-link {
            border-bottom: 1px solid ${menuBackgroundColor};
          }
          .btn-primary {
              color: ${buttonFontColor};
              background-color: ${buttonBackgroundColor};
              border-color: ${buttonBackgroundColor};
          }
          .btn-primary[disabled] {
              color: ${buttonFontColor};
              background-color: ${buttonBackgroundColor};
              border-color: ${buttonBackgroundColor};
              opacity: 0.6;
          }
          .btn-primary:hover,
          .btn-primary:active,
          .btn-primary:focus {
            color: ${buttonFontColor};
            background-color: ${buttonBackgroundColor};
            border-color: ${buttonBackgroundColor};
            opacity: 0.8;
          }
          .btn-primary:not(:disabled):not(.disabled):active,
          .btn-primary:not(:disabled):not(.disabled).active,
          .show > .btn-primary.dropdown-toggle {
            color: ${buttonFontColor};
            background-color: ${buttonBackgroundColor};
            border-color: ${buttonBackgroundColor};
            opacity: 0.8;
          }
          [class*="sidebar-light-"] .sidebar a, .footer-menu {
            color: ${menuFontColor};
          }
          [class*="sidebar-light-"] .nav-treeview > .nav-item > .nav-link,
          .navbar-light .navbar-nav .nav-link:hover,
          .navbar-light .navbar-nav .nav-link:focus {
            color: ${menuFontColor};
            opacity: 0.7;
          }
          [class*="sidebar-light-"] .nav-sidebar > .nav-item.menu-open > .nav-link,
          .navbar-light .navbar-nav .nav-link {
            color: ${menuFontColor};
          }
          [class*="sidebar-light-"] .nav-sidebar > .nav-item.menu-open > .nav-link,
          [class*="sidebar-light-"] .nav-sidebar > .nav-item:hover > .nav-link
          {
              background-color: ${menuFontColor}de;
              color: ${menuBackgroundColor};
          }
          [class*="sidebar-light-"] .nav-sidebar > .nav-item > .nav-link:active,
          [class*="sidebar-light-"] .nav-sidebar > .nav-item > .nav-link:focus {
            background-color: ${menuFontColor};
            color: ${menuBackgroundColor}de;
          }
          [class*="sidebar-light-"] .nav-treeview > .nav-item > .nav-link:hover,
          [class*="sidebar-light-"] .nav-treeview > .nav-item > .nav-link:focus {
            background-color: ${menuFontColor}f0;
            color: ${menuBackgroundColor};
          }
          `;
    const style = document.createElement('style');
    style.appendChild(document.createTextNode(css));
    document.head.appendChild(style);
  }

}
